import { isInpatientBilling } from 'constants/treatment';
import { isEndoscopyVisit } from 'utils/endoscopyProtocol';

function bookingServiceName(item) {
  return String(
    item?.serviceName ?? item?.service_name ?? item?.service?.name ?? ''
  ).toLowerCase();
}

/** ЭГДС, колоноскопия и УЗИ — раздел «Исследования», не общий амбулаторный список. */
export function isInvestigationBooking(item) {
  if (!item || isOperationBooking(item)) return false;
  if (isEndoscopyVisit(item)) return true;
  return bookingServiceName(item).includes('узи');
}

/** Операции только в «Хирургии», не в амбулаторных и не в стационаре. */
export function isOperationBooking(item) {
  if (!item) return false;
  const kind =
    item.serviceKind ??
    item.service_kind ??
    item.service?.serviceKind ??
    item.service?.service_kind ??
    '';
  if (kind === 'operation') return true;
  return bookingServiceName(item).includes('операц');
}

/** Операция, которой открывают историю «Бейтап баяны» (амбулаторно и стационарно, не перевязка). */
export function isBeitapHistoryBooking(item) {
  if (!isOperationBooking(item)) return false;
  const name = String(
    item.serviceName ?? item.service_name ?? item.service?.name ?? ''
  ).toLowerCase();
  return !name.includes('перевяз');
}

export function isInpatientBooking(item) {
  if (!item) return false;
  if (
    isInpatientBilling(
      item.careType ?? item.care_type,
      item.billingMode ?? item.billing_mode
    )
  ) {
    return true;
  }
  return bookingServiceName(item).includes('стационар');
}

export function compareBookingsByTime(a, b) {
  const timeCmp = String(a?.time || '').localeCompare(String(b?.time || ''));
  if (timeCmp !== 0) return timeCmp;
  return String(a?.clientName || a?.client_name || '').localeCompare(
    String(b?.clientName || b?.client_name || ''),
    'ru'
  );
}

/** Для архива завершённых: сначала новые даты, внутри дня — позднее время. */
export function compareBookingsByDateTimeDesc(a, b) {
  const dateCmp = String(b?.date || '').localeCompare(String(a?.date || ''));
  if (dateCmp !== 0) return dateCmp;
  return compareBookingsByTime(b, a);
}

export function sortBookingsByDateTimeDesc(items) {
  return [...(items || [])].sort(compareBookingsByDateTimeDesc);
}

/** Сначала амбулаторные, затем стационар; внутри группы — по времени. */
export function sortBookingsByCareTypeAndTime(items) {
  return [...items].sort((a, b) => {
    const groupA = isInpatientBooking(a) ? 1 : 0;
    const groupB = isInpatientBooking(b) ? 1 : 0;
    if (groupA !== groupB) return groupA - groupB;
    return compareBookingsByTime(a, b);
  });
}

export function groupBookingsByCareType(items) {
  const outpatient = [];
  const inpatient = [];
  (items || []).forEach((item) => {
    if (isOperationBooking(item)) return;
    if (isInpatientBooking(item)) inpatient.push(item);
    else outpatient.push(item);
  });
  return {
    outpatient: outpatient.sort(compareBookingsByTime),
    inpatient: inpatient.sort(compareBookingsByTime),
  };
}

/** Амбулаторные / исследования / стационар — для меню врача и «Мой день». */
export function groupBookingsByDoctorReceptionSection(items) {
  const investigations = [];
  const outpatient = [];
  const inpatient = [];
  (items || []).forEach((item) => {
    if (isOperationBooking(item)) {
      return;
    }
    if (isInvestigationBooking(item)) {
      investigations.push(item);
      return;
    }
    if (isInpatientBooking(item)) {
      inpatient.push(item);
      return;
    }
    outpatient.push(item);
  });
  return {
    investigations: investigations.sort(compareBookingsByTime),
    outpatient: outpatient.sort(compareBookingsByTime),
    inpatient: inpatient.sort(compareBookingsByTime),
  };
}

export function filterBookingsForDoctorSection(items, section) {
  const list = Array.isArray(items) ? items : [];
  if (section === 'investigations') {
    return list.filter(isInvestigationBooking).sort(compareBookingsByTime);
  }
  if (section === 'outpatient') {
    return list
      .filter(
        (item) =>
          !isOperationBooking(item) &&
          !isInpatientBooking(item) &&
          !isInvestigationBooking(item)
      )
      .sort(compareBookingsByTime);
  }
  if (section === 'inpatient') {
    return list
      .filter((item) => isInpatientBooking(item) && !isOperationBooking(item))
      .sort(compareBookingsByTime);
  }
  return list;
}
